import React, { useState } from 'react';
import { Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  count?: number;
  children: React.ReactNode;
  classes: any;
}

export const CollapsibleFieldSection = ({ title, count, children, classes }: Props) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(true);

  const entryLabel =
    count !== undefined
      ? count === 1
        ? t('consentForm.step2.sectionEntry', { count })
        : t('consentForm.step2.sectionEntries', { count })
      : null;

  return (
    <div className={classes.sectionContainer}>
      <div
        className={classes.sectionHeader}
        onClick={() => setExpanded(prev => !prev)}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && setExpanded(prev => !prev)}
      >
        <span className={classes.sectionTitle}>{title}</span>
        <div className={classes.sectionHeaderRight}>
          {entryLabel && <span className={classes.sectionEntryCount}>{entryLabel}</span>}
          {expanded ? (
            <ExpandLessIcon className={classes.sectionChevron} />
          ) : (
            <ExpandMoreIcon className={classes.sectionChevron} />
          )}
        </div>
      </div>
      <Collapse in={expanded}>
        <div className={classes.sectionContent}>{children}</div>
      </Collapse>
    </div>
  );
};
